import React, { ReactElement } from 'react'
import Modal from '@material-ui/core/Modal'
import SubmitButton from '../buttons/SubmitButton'
import { CrossIcon } from '../icons/CrossIcon'

import classes from './styles.module.scss'

interface Props {
  open: boolean
  onClose: any
  onSave?: any
  title: string
  children: ReactElement
  titleIcon?: ReactElement
  customFooter?: ReactElement
  containerClasses?: string
  bodyClasses?: string
  withFooter?: boolean
  primaryButtonTitle?: string
  hasPrimaryButton?: boolean
  isPrimaryButtonDisabled?: boolean
  cancelButtonStyles?: React.CSSProperties
  disableClose?: boolean
}

const ModalTemplate: React.FC<Props> = ({
  open,
  onClose,
  onSave,
  title,
  children,
  customFooter,
  containerClasses,
  bodyClasses,
  titleIcon,
  withFooter = true,
  primaryButtonTitle,
  hasPrimaryButton = true,
  isPrimaryButtonDisabled = false,
  cancelButtonStyles,
  disableClose = false
}) => {
  const handleClose = () => {
    if (disableClose) {
      return
    }

    onClose()
  }

  return (
    <Modal open={open} onClose={handleClose}>
      <div className={`${classes.container} ${containerClasses || ''}`}>
        <div className={classes.header}>
          <p className={classes.title}>
            {title}
            {titleIcon}
          </p>
          <div className={`${classes.closeButton} ${disableClose ? classes.closeButtonDisabled : ''}`} onClick={handleClose}>
            <CrossIcon color={'var(--color-spun-pearl-grey)'} />
          </div>
        </div>
        <div className={`${classes.body} ${bodyClasses || ''}`}>{children}</div>
        {withFooter && (
          <div className={classes.footer}>
            <div className={classes.buttons}>
              <SubmitButton
                title="Cancel"
                type="primary_with_border"
                styles={{ borderRadius: 4, ...cancelButtonStyles }}
                onClick={handleClose}
                disabled={disableClose}
              />
              {hasPrimaryButton && <SubmitButton
                title={primaryButtonTitle || 'Save'}
                type="primary"
                styles={{ borderRadius: 4 }}
                onClick={() => onSave && onSave()}
                disabled={isPrimaryButtonDisabled}
              />}
            </div>
            {customFooter}
          </div>
        )}
      </div>
    </Modal>
  )
}

export default ModalTemplate
